export const colors = {
  green: '#204651',
  gray: '#bfb3a5',
  beige: `#fff8ee`,
  darkBeige: `#f3ede6`,
  lightBeige: `#FFFCF7`,
  lightGreen: `#B6BBB6`,
  lightDarkGreen: `#879596`,
  lightBlue: `#5fa8d3`,
  lightRed: `#FB6A61`,
  white: `#ffffff`
}